module.exports = __webpack_public_path__ + "9488d02b/img/ion_calendar-number.3ac5bd07.svg";